const PageUrlCategory = (api: any) => ({
  searchPageURLCategory: (findOptions: any) =>
    api.post("/pageURLCategory/searchPageURLCategory.php", {}, findOptions),
  createPageURLCategory: (payload: { categoryName: string }) =>
    api.post("/pageURLCategory/createPageURLCategory.php", {}, payload),
  updatePageURLCategory: (payload: { categoryName: string }) =>
    api.put("/pageURLCategory/updatePageURLCategory.php", {}, payload),
  deletePageURLCategory: (categoryId: number) =>
    api.remove(
      "/pageURLCategory/deletePageURLCategory.php",
      {},
      { categoryId }
    ),
});

export default PageUrlCategory;
